module.exports = __webpack_public_path__ + "img/info.d46ac15d.svg";